import { BaseRestDataProvider } from './BaseRestDataProvider';

export interface BackupRestoreResult {
  message: string;
}

export class BackupRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/backup');
  }

  async downloadBackup(): Promise<Blob> {
    return this.getBlob('/download');
  }

  async restoreBackup(file: File, includeUsers: boolean = false): Promise<BackupRestoreResult> {
    const formData = new FormData();
    formData.append('file', file);

    const token = BaseRestDataProvider.getToken();
    const cb = `_cb=${Math.random().toString(36).slice(2)}`;
    const url = `${this.baseUrl}/restore?${cb}&includeUsers=${includeUsers}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData,
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }
}

export default BackupRestDataProvider;
